import React, { Component } from 'react';
import { renderRoutes } from 'react-router-config';
import { ParallaxProvider } from 'react-skrollr';
import _ from 'lodash';
import { Header, Footer } from '../components';
import { withRedux } from "../hoc";
import { initApp } from "../actions";

const mapStateToProps = state => {
  return {
    t: _.get(state, "t"),
    language: _.get(state, "language"),
  };
};

const actions = {
  initApp
};

@withRedux(mapStateToProps, actions)
export default class Root extends Component {

  componentWillMount() {
    this.props.actions.initApp();
  }

  render() {
    const { route } = this.props;
    return (
      <React.Fragment>
        <Header />
        <ParallaxProvider
          init={{
            smoothScrollingDuration: 800,
            smoothScrolling: true,
            forceHeight: false
          }}
        >
          <div className="main-content" style={{ overflow: 'hidden' }}>{renderRoutes(route.routes)}</div>
        </ParallaxProvider>
        <Footer />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Root.js